import React, { Component } from 'react';
import { Form, Input, Spin } from 'antd';
import { connect } from 'react-redux';
import { H1, PrimaryButton, PrimaryButtonV2 } from 'utils';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { authActions } from 'redux/actions';
import isEmpty from 'loadsh/isEmpty';
import { Redirect } from 'react-router-dom';
import { formValidateMessages } from 'utils';
import { GoogleLogin } from '@react-oauth/google';
import ExternalLinkOnLogin from 'components/ExternalLink/ExternalLinkOnLogin';
const FormItem = Form.Item;

class SingUpFormV2 extends Component {
  static propTypes = {
    handleCurrentFormState: PropTypes.func,
    loading: PropTypes.bool,
    errors: PropTypes.array,
    register: PropTypes.func.isRequired,
    user: PropTypes.object,
    singUpSuccess: PropTypes.bool,
    handelCloseModal: PropTypes.func,
  };

  onFinish = (values) => {
    const { register } = this.props;
    register(values);
  };

  componentDidUpdate(prevProps) {
    const { singUpSuccess, handelCloseModal } = this.props;
    if (singUpSuccess && !prevProps.singUpSuccess) {
      handelCloseModal && handelCloseModal();
    }
  }

  handleSuccess = (response) => {
    const token = response.credential;
    this.props.loginWithGoogle({ token });
    if (this.props.onRegisterSuccess) {
      this.props.onRegisterSuccess();
    } else {
      this.setState({ redirectToProfile: true });
    }
    this.setState({ redirectToProfile: true });
  };

  handleError = () => {
    console.log('Google login failed');
  };

  render() {
    const {
      handleCurrentFormState,
      loading,
      user,
      singUpSuccess,
      handelCloseModal,
      setDoPayment,
      navigate,
      login,
    } = this.props;
    const userToken = localStorage.getItem('access-token');
    const client = localStorage.getItem('client');
    const isLoggedIn = !isEmpty(user) && userToken && client;
    // if (singUpSuccess && navigate === false) {
    //   handelCloseModal();
    // }
    return (
      <Spin spinning={loading}>
        {singUpSuccess && (
          this.props.onRegisterSuccess
            ? this.props.onRegisterSuccess()
            : (navigate && <Redirect to={{ pathname: '/welcome' }} />)
        )}
        {isLoggedIn && <ExternalLinkOnLogin href="/" />}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '4px',
            textAlign: 'left',
          }}
        >
          <h3>Willkommen bei commonsplace!</h3>
          <p>Bitte registriere dich, um fortzufahren.</p>
        </div>
        <Form
          name="sing-up"
          validateMessages={formValidateMessages}
          onFinish={this.onFinish}
          layout='vertical'
        >
          <FormItem
            name="firstName"
            label="Vorname"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder='Dein Name' />
          </FormItem>
          <FormItem
            name="lastName"
            label="Nachname"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input placeholder='Dein Nachname' />
          </FormItem>
          <FormItem
            name="email"
            label="E-Mail"
            rules={[
              {
                required: true,
                message: 'Bitte gib deine E-Mail-Adresse ein.',
              },
            ]}
          >
            <Input type="email" placeholder='Deine E-Mail-Adresse' />
          </FormItem>
          <FormItem
            name="password"
            label="Passwort"
            rules={[
              {
                required: true,
                message: 'Bitte gib dein Passwort ein.',
              },
            ]}
            hasFeedback
          >
            <Input.Password placeholder='Gib ein Passwort ein' />
          </FormItem>

          <FormItem
            name="passwordConfirmation"
            label="Passwort wiederholen"
            dependencies={['password']}
            hasFeedback
            rules={[
              {
                required: true,
                message: 'Bitte bestätigte dein Passwort!',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    'Die eingegebenen Passwörter stimmen nicht überein!'
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder='Passwort erneut eingeben' />
          </FormItem>

          <div className="login-actions" >
            <Link to="#!" onClick={() => handleCurrentFormState('login')}>
              Bereits registriert? Jetzt anmelden!
            </Link>
          </div>

          <FormItem>
            <PrimaryButtonV2 htmltype="submit" style={{ width: "100%" }}>Registrieren</PrimaryButtonV2>
          </FormItem>

          <GoogleLogin
            onSuccess={this.handleSuccess}
            onError={this.handleError}
          />
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => {
  const { user, loading, errors, singUpSuccess } = state.authentication;
  return {
    user,
    loading,
    errors,
    singUpSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  register: (user) => dispatch(authActions.register(user)),
  loginWithGoogle: (user) => dispatch(authActions.loginWithGoogle(user)),
});
export default connect(mapStateToProps, mapDispatchToProps)(SingUpFormV2);
